import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HorizontalScrollComponent } from './horizontal-scroll.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
    declarations: [HorizontalScrollComponent],
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [
        HorizontalScrollComponent
    ]
})
export class HorizontalScrollModule { }
